'use client';
import { factory, Box, Grid, Flex, Typography, DsmColor, omitText, Checkbox } from '@kohler-dsm-library/kohler-core';
import { CloseIcon, ArrowLeftIcon } from '@kohler-dsm-library/kohler-icons';
import clsx from 'clsx';
import React, { isValidElement } from 'react';
import classes from './StoreMenu.module.css.mjs';
import { ZipCodeInputField } from './ZipCodeInputField/ZipCodeInputField.mjs';

const StoreMenu = factory((props, ref) => {
  const {
    className,
    heading,
    CTAs,
    eyebrow,
    subheading,
    storeInfo,
    zipCodeInput,
    setStoreCTA,
    setMenuType,
    setIsOpenMobileMenu,
    id = "store-menu",
    ...rest
  } = props;
  const classNames = clsx(className, "kohler-store-menu-root", classes.storeMenu);
  return /* @__PURE__ */ React.createElement(Box, { id, component: "div", ref, className: classNames, ...rest }, /* @__PURE__ */ React.createElement(Grid, { className: clsx("center-grid", classes.storeMenuMainGrid) }, /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuMobileClose }, /* @__PURE__ */ React.createElement(
    Box,
    {
      component: "button",
      type: "button",
      "aria-label": "close store menu",
      onClick: () => {
        setMenuType?.(null);
        setIsOpenMobileMenu?.(false);
      },
      className: classes.storeMenuMobileCloseIcon
    },
    /* @__PURE__ */ React.createElement(CloseIcon, { withBoundingBox: false, size: "medium" })
  ), /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-regular-m",
      component: "button",
      type: "button",
      textColor: DsmColor.ContentSecondary,
      className: classes.storeMenuMobileBackText,
      onClick: () => setMenuType?.(null)
    },
    /* @__PURE__ */ React.createElement(ArrowLeftIcon, { withBoundingBox: false, size: "small" }),
    " Menu"
  )), /* @__PURE__ */ React.createElement(Flex, { className: clsx(classes.storeMenuMainContent, !storeInfo && classes.storeMenuMainFullContent) }, /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuContentHeading }, eyebrow && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(eyebrow.text) ? "div" : eyebrow.component || "p",
      ...omitText(eyebrow),
      size: "label-medium-m",
      textColor: DsmColor.ContentPrimary
    },
    eyebrow.text
  ), /* @__PURE__ */ React.createElement(Typography, { ...omitText(heading), size: "navigation-overlay-title", textColor: DsmColor.ContentPrimary }, heading.text), subheading && /* @__PURE__ */ React.createElement(
    Typography,
    {
      component: isValidElement(subheading.text) ? "div" : subheading.component || "p",
      ...omitText(subheading),
      size: "label-regular-m",
      textColor: DsmColor.ContentPrimary
    },
    subheading.text
  )), storeInfo && /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuContentInfoContainer }, /* @__PURE__ */ React.createElement(Typography, { className: classes.storeMenuContentInfo, size: "label-regular-m", component: "div" }, storeInfo), setStoreCTA && /* @__PURE__ */ React.createElement(Checkbox, { ...setStoreCTA }))), /* @__PURE__ */ React.createElement(Flex, { className: classes.storeMenuZipContainer }, zipCodeInput.eyebrow && /* @__PURE__ */ React.createElement(
    Typography,
    {
      size: "label-medium-m",
      className: classes.storeMenuContentZipContainerEyebrow,
      component: isValidElement(zipCodeInput.eyebrow.text) ? "div" : zipCodeInput.eyebrow.component || "p"
    },
    zipCodeInput.eyebrow.text
  ), /* @__PURE__ */ React.createElement(
    ZipCodeInputField,
    {
      ...zipCodeInput,
      handleSubmit: (value) => {
        zipCodeInput.handleSubmit?.(value);
        setMenuType?.(null);
        setIsOpenMobileMenu?.(false);
      }
    }
  ), CTAs && /* @__PURE__ */ React.createElement("ul", { className: classes.storeMenuContentList }, CTAs.map((CTA) => {
    return /* @__PURE__ */ React.createElement("li", { key: CTA.text }, /* @__PURE__ */ React.createElement(
      Typography,
      {
        component: CTA.component || "a",
        ...omitText(CTA),
        className: clsx(classes.storeMenuContentListItemLink),
        size: "label-regular-m",
        style: { textDecoration: "underline" }
      },
      CTA.text
    ));
  })))));
});

export { StoreMenu };
